import { authenticatedAjax, REQUEST } from "../../../../config/ajax-wrapper";
import { AnyAction } from "redux";
import { 
    CONSULTAR_GLOSAS,
    GLOSAS_CONSULTADAS,
    ERROR_CONSULTANDO_GLOSAS,
    glosasConsultadas, 
    errorConsultandoGlosas, 
    GESTIONAR_GLOSAS,
    GLOSAS_ENVIADAS,
    ERROR_GESTIONANDO_GLOSA,
    glosasEnviadas,
    errorGestionandoGlosa,
    OBTENER_XLS_DATOS_GLOSAS,
    XLS_DATOS_GLOSAS_OBTENIDO,
    ERROR_OBTENIENDO_XLS_DATOS_GLOSAS,
    XLSDatosGlosasObtenido,
    errorObteniendoXLSDatosGlosas,
    errorAutorizacionGestionGlosas,
    ERROR_AUTORIZACION_GESTION_GLOSAS,
    GLOSA_GESTIONADA,
    glosaGestionada,
    INICIAR_GESTION_GLOSAS,
    GESTIONAR_MASIVO_GLOSAS,
    masivoGlosasGestionado,
    ERROR_GESTIONANDO_MASIVO_GLOSAS,
    MASIVO_GLOSAS_GESTIONADO,
    errorGestionandoMasivoGlosas
} from "./bandejaGlosasActions";
import { GlosaEmpleador, FiltroGlosasEmpleador, DatosGlosasXLS, RespuestaGestionGlosas } from "../modelo/GlosaEmpleador";
import {DATE_FORMAT_WITH_HOUR} from "../../../general/componentes/DatePicker";
import * as moment from "moment";
import { errorAutorizacion } from "src/co/sura/inicio/modulos/inicioActions";
import fileDownload from "js-file-download";
import { EstadoGlosa } from "../modelo/EstadosGlosa";
import { crearPlantillaXLS } from "../../../general/componentes/GenerarPlantillaXLS";
import { cabeceraGlosasSAT, LibroDocumentoXLS, TIPO_GLOSA_SAT } from "../../../general/modelo/PlanillasXLS";
import { OrdenamientoGlosas, TipoOrdenamiento, ParamOrdenamientoGlosas } from "../modelo/OrdenamientoGlosas";

export const consultarGlosasEpic = action$ =>
    action$.ofType(CONSULTAR_GLOSAS)
        .mergeMap((action: any) => {

            const url = `sat/glosas?${obtenerFiltroGlosasEmpleador(action.filtroGlosasEmpleador)}`;

            return authenticatedAjax
                .get(
                    url
                )
                .map((response) => {
                    const respuesta = JSON.parse(response.response);
                    return glosasConsultadas(parseGlosasEmpleador(respuesta, action.ordenamiento), respuesta.paginas, respuesta.totalGlosasEmpleador);
                })
                .catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacion(response.response, response.status)];
                    }
                    return [errorConsultandoGlosas()];
                });
        });       

export const gestionarGlosasEpic = action$ =>
    action$.ofType(GESTIONAR_GLOSAS)
        .mergeMap((action: any) => {
            return authenticatedAjax
                .post(
                    'sat/gestionar-glosas', {
                        glosaEmpleador: action.glosaEmpleador,
                        datosGestionGlosas: {
                            codigoProceso: action.codigoProceso,
                            observacion: action.observacion,
                            dniUsuarioOperacion: action.dniUsuarioGestion,
                            fechaEnvio: action.fechaEnvio
                        }
                    },
                    {'Content-Type': 'application/json'}
                ).map((response) => {
                    const respuesta = response.response;
                    const glosaRespuesta: RespuestaGestionGlosas = {
                        exitoGestion: true,
                        codigoRespuesta: response.status,
                        mensajeRespuesta: response.response && respuesta.mensajeRespuesta ? respuesta.mensajeRespuesta : 'Ok',
                        codigoProceso: action.codigoProceso,
                        observacionGestion: action.observacion,
                        dniUsuarioGestion: action.dniUsuarioGestion,
                        glosaEmpleador: action.glosaEmpleador
                    };
                    if(action.numgestion >= action.totalgestiones) {
                        return glosasEnviadas(glosaRespuesta);
                    }
                    return glosaGestionada(glosaRespuesta);
                })
                .catch((response) => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacionGestionGlosas()];
                    }
                    const respuesta = response.response;
                    const glosaRespuesta: RespuestaGestionGlosas = {
                        exitoGestion: false,
                        codigoRespuesta: response.status ? response.status : 404,
                        mensajeRespuesta: response.response && respuesta.mensajeRespuesta ? respuesta.mensajeRespuesta : 'Error no controlado',
                        codigoProceso: action.codigoProceso,
                        observacionGestion: action.observacion,
                        dniUsuarioGestion: action.dniUsuarioGestion,
                        glosaEmpleador: action.glosaEmpleador
                    };
                    if(action.numgestion >= action.totalgestiones) {
                        return [glosasEnviadas(glosaRespuesta)];
                    }
                    return [errorGestionandoGlosa(glosaRespuesta)];
                });
        });

export const obtenerXLSDatosGlosasEpic = action$ =>
    action$.ofType(OBTENER_XLS_DATOS_GLOSAS)
        .mergeMap((action: any) => {

            const url = `sat/glosas/xls`;

            return authenticatedAjax
                .post(
                    url,
                    action.filtroGlosasEmpleador,
                    {'Content-Type': 'application/json'}
                )
                .map((response) => {
                    const tipoGlosa = definirTipo(action);
                    const respuesta = response.response;
                    const excelBlob: Blob = construirXLS(respuesta, tipoGlosa);
                    const nombreArchivo = `reporte_sat_${moment(moment.now()).format("DD_MM_YYYY_HHmmss")}.xlsx`;
                    fileDownload(
                        excelBlob,
                        nombreArchivo,
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    );
                    return XLSDatosGlosasObtenido();
                }).catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacionGestionGlosas()];
                    } else {
                        return [errorObteniendoXLSDatosGlosas()];
                    }
                });
        });

export const masivoGestionGlosasEpic = action$ =>
    action$.ofType(GESTIONAR_MASIVO_GLOSAS)
        .mergeMap((action: any) => {
            return authenticatedAjax
                .post(
                    'sat/masivo-glosas', action.gestionGlosasMasivo,
                    {'Content-Type': 'application/json'}
                )
                .map((response) => {
                    const respuesta = response.response;
                    return masivoGlosasGestionado(respuesta.mensajeRespuesta, respuesta.solicitudExito, respuesta.datos);
                })
                .catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacionGestionGlosas()];
                    } else {
                        const respuesta = response.response;
                        const mensajeRespuesta = (response.response && respuesta.mensajeRespuesta) ? respuesta.mensajeRespuesta : "Error no controlado en la aplicación";
                        return [errorGestionandoMasivoGlosas(mensajeRespuesta)];
                    }
                });
        });

export const glosasReducer = ( state = {
    estado: REQUEST.NONE,
    estadoGestionGlosas: REQUEST.NONE,
    estadoXLS: REQUEST.NONE,
    estadoDetalles: REQUEST.NONE,
    errorMasivoGlosas: false,
    mensajeAction: undefined,
    mensajeUsuario: false,
    glosasEmpleador: [],
    paginaActual: 0,
    tamanoPagina: 10,
    totalGlosasConsulta: 0,
    tipoServicioConsulta: undefined,
    detallesGlosaEmpleador: undefined,
    listaRespuestaGestionGlosas: [],
    totalGlosasGestion: 0
}, action: AnyAction) => {
    switch (action.type) {

        case CONSULTAR_GLOSAS: 
            return {
                ...state, 
                estado: REQUEST.PENDING,
                estadoGestionGlosas: REQUEST.NONE,
                estadoXLS: REQUEST.NONE,
                errorMasivoGlosas: false,
                mensajeAction: undefined,
                mensajeUsuario: false,
                totalGlosasConsulta: 0,
                glosasEmpleador: [],
                listaRespuestaGestionGlosas: [],
                totalGlosasGestion: 0,
                paginaActual: action.filtroGlosasEmpleador.pagina,
                tamanoPagina: action.filtroGlosasEmpleador.registrosPorPagina,
                tipoServicioConsulta: action.filtroGlosasEmpleador.tipoTransaccion,
                
            };
        case GLOSAS_CONSULTADAS:
            return {
                ...state,
                estado: REQUEST.SUCCESS,
                glosasEmpleador: action.glosasEmpleador,
                paginas: action.paginas,
                totalGlosasConsulta: action.totalGlosasEmpleador
            };
        case ERROR_CONSULTANDO_GLOSAS:
            return {
                ...state,
                estado: REQUEST.ERROR,
                totalGlosasConsulta: 0,
                glosasEmpleador: [],
                listaRespuestaGestionGlosas: [],
                totalGlosasGestion: 0,
                tipoServicioConsulta: undefined,
            };
        case INICIAR_GESTION_GLOSAS:
            return {
                ...state,
                estadoGestionGlosas: REQUEST.PENDING,
                errorMasivoGlosas: false,
                listaRespuestaGestionGlosas: [],
                totalGlosasGestion: action.totalGlosasGestion,
                mensajeAction: "Gestionando glosas",
                mensajeUsuario: false
            };
        case GESTIONAR_GLOSAS:
            return {
                ...state,
                glosasEmpleador: actualizarGlosasGestionadas(state.glosasEmpleador, action.glosaEmpleador),
            };
        case GLOSAS_ENVIADAS:
            return {
                ...state,
                mensajeAction: undefined,
                estadoGestionGlosas: (state.listaRespuestaGestionGlosas.length+1) >= state.totalGlosasGestion ? 
                        calcularEstadoGlosasGestion(state.listaRespuestaGestionGlosas, action.respuestaGestionGlosa) : state.estadoGestionGlosas,
                glosaEmpleador: actualizarGlosasGestionFallo(state.glosasEmpleador, action.respuestaGestionGlosa),
                listaRespuestaGestionGlosas: adicionarListaRespuestaGlosaProcesada(state.listaRespuestaGestionGlosas, action.respuestaGestionGlosa)
            };
        case GLOSA_GESTIONADA:
            return {
                ...state,
                estadoGestionGlosas: (state.listaRespuestaGestionGlosas.length+1) >= state.totalGlosasGestion ? 
                        calcularEstadoGlosasGestion(state.listaRespuestaGestionGlosas, action.respuestaGestionGlosa) : state.estadoGestionGlosas,
                listaRespuestaGestionGlosas: adicionarListaRespuestaGlosaProcesada(state.listaRespuestaGestionGlosas, action.respuestaGestionGlosa)
            };
        case ERROR_GESTIONANDO_GLOSA:
            return {
                ...state,
                estadoGestionGlosas: (state.listaRespuestaGestionGlosas.length+1) >= state.totalGlosasGestion ? 
                        calcularEstadoGlosasGestion(state.listaRespuestaGestionGlosas, action.respuestaGestionGlosa) : state.estadoGestionGlosas,
                glosaEmpleador: actualizarGlosasGestionFallo(state.glosasEmpleador, action.respuestaGestionGlosa),
                listaRespuestaGestionGlosas: adicionarListaRespuestaGlosaProcesada(state.listaRespuestaGestionGlosas, action.respuestaGestionGlosa)
            };
        case ERROR_AUTORIZACION_GESTION_GLOSAS:
            return {
                ...state,
                estadoGestionGlosas: REQUEST.FORBIDDEN
            };
        case OBTENER_XLS_DATOS_GLOSAS:
            return {
                ...state,
                estadoXLS: REQUEST.PENDING
            };
        case XLS_DATOS_GLOSAS_OBTENIDO:
            return {
                ...state,
                estadoXLS: REQUEST.SUCCESS
            };
        case ERROR_OBTENIENDO_XLS_DATOS_GLOSAS:
            return {
                ...state,
                estadoXLS: REQUEST.ERROR
            };
        case GESTIONAR_MASIVO_GLOSAS:
            return {
                ...state,
                estadoGestionGlosas: REQUEST.PENDING,
                errorMasivoGlosas: false,
                mensajeAction: "Gestionando glosas"
            };
        case MASIVO_GLOSAS_GESTIONADO:
            return {
                ...state,
                glosasEmpleador: masivoGlosasGestionadas(state.glosasEmpleador),
                mensajeAction: action.solicitudExito ? 
                    `Se han enviado exitosamente ${action.datos.glosasGestion} glosas para gestionar a SAT. Tipo Gestión: ${action.datos.gestion.replace(/\_/gi,' ')}` : action.mensajeRespuesta,
                errorMasivoGlosas: false,
                estadoGestionGlosas: REQUEST.SUCCESS
            };
        case ERROR_GESTIONANDO_MASIVO_GLOSAS:
            return {
                ...state,
                mensajeAction: action.mensajeRespuesta,
                estadoGestionGlosas: REQUEST.ERROR,
                errorMasivoGlosas: true,
            };
        default:
            return state;
    }
};

const parseGlosasEmpleador = (respuestaHttp: any, ordenamientoGlosas: OrdenamientoGlosas): Array<GlosaEmpleador> => {
    const listaGlosas = respuestaHttp.glosasEmpleador.map((glosa: GlosaEmpleador) => {
        const usuarioOperacion: string = glosa.usuario ? glosa.usuario : '';
        return {
            dniEmpleador: glosa.dniEmpleador,
            npoliza: glosa.npoliza,
            nombreEmpleador: glosa.nombreEmpleador,
            uen: glosa.uen,
            estado: glosa.estado ? glosa.estado : "DESCONOCIDO",
            codigoServicio: glosa.codigoServicio,
            fechaOperacion: moment(glosa.fechaOperacion).format(DATE_FORMAT_WITH_HOUR),
            codigoGlosa: glosa.codigoGlosa ? glosa.codigoGlosa : '',
            descripcionGlosa: glosa.descripcionGlosa ? glosa.descripcionGlosa : '',
            detalleGlosa: glosa.detalleGlosa ? glosa.detalleGlosa : '',
            respuestaSat: glosa.respuestaSat ? glosa.respuestaSat : '',
            glosaBloqueante: glosa.glosaBloqueante ? glosa.glosaBloqueante : '',
            usuario: usuarioOperacion === 'MODSATADMARL' ? 'AUTOMÁTICO' : usuarioOperacion,
            emailUsuario: glosa.emailUsuario ? glosa.emailUsuario : '',
            fuenteIngreso: glosa.fuenteIngreso,
            observacionGestion: glosa.observacionGestion ? glosa.observacionGestion : '',
            consecutivo: glosa.consecutivo,
            estadoPoliza: glosa.estadoPoliza ? glosa.estadoPoliza : ''
        };  
    });

    if(ordenamientoGlosas) {
        const ordenamientoTipo = ordenamientoGlosas.tipoOrdenamiento === TipoOrdenamiento.ASCENDENTE ? 1 : -1; 
        return listaGlosas.sort((a, b) => {
            switch(ordenamientoGlosas.paramOrdenamiento) {
                case ParamOrdenamientoGlosas.FECHA_OPERACION:
                    if (moment(a.fechaOperacion, 'DD-MM-YYYY HH:mm').toDate().getTime() > moment(b.fechaOperacion, 'DD-MM-YYYY HH:mm').toDate().getTime()) return 1 * ordenamientoTipo;
                    if (moment(a.fechaOperacion, 'DD-MM-YYYY HH:mm').toDate().getTime() < moment(b.fechaOperacion, 'DD-MM-YYYY HH:mm').toDate().getTime()) return -1 * ordenamientoTipo;
                    return 0; 
                case ParamOrdenamientoGlosas.DNI_EMPLEADOR:
                    if (a.dniEmpleador > b.dniEmpleador) return 1 * ordenamientoTipo;
                    if (a.dniEmpleador < b.dniEmpleador) return -1 * ordenamientoTipo;
                    return 0;
                case ParamOrdenamientoGlosas.NOMBRE_EMPLEADOR:
                    if (a.nombreEmpleador > b.nombreEmpleador) return 1 * ordenamientoTipo;
                    if (a.nombreEmpleador < b.nombreEmpleador) return -1 * ordenamientoTipo;
                    return 0;
                case ParamOrdenamientoGlosas.UEN:
                    if (a.uen > b.uen) return 1 * ordenamientoTipo;
                    if (a.uen < b.uen) return -1 * ordenamientoTipo;
                    return 0;
                case ParamOrdenamientoGlosas.CODIGO_SERVICIO:
                    if (a.codigoServicio > b.codigoServicio) return 1 * ordenamientoTipo;
                    if (a.codigoServicio < b.codigoServicio) return -1 * ordenamientoTipo;
                    return 0;
                case ParamOrdenamientoGlosas.CODIGO_GLOSA:
                    if (a.codigoGlosa > b.codigoGlosa) return 1 * ordenamientoTipo;
                    if (a.codigoGlosa < b.codigoGlosa) return -1 * ordenamientoTipo;
                    return 0;
                case ParamOrdenamientoGlosas.ESTADO_GLOSA:
                    if (a.estado > b.estado) return 1 * ordenamientoTipo;
                    if (a.estado < b.estado) return -1 * ordenamientoTipo;
                    return 0;
                case ParamOrdenamientoGlosas.ESTADO_POLIZA:
                    if (a.estadoPoliza > b.estadoPoliza) return 1 * ordenamientoTipo;
                    if (a.estadoPoliza < b.estadoPoliza) return -1 * ordenamientoTipo;
                    return 0;
                default:
                    return 0;
            }
        });
    }

    return listaGlosas;
};

const obtenerFiltroGlosasEmpleador = (filtroGlosasEmpleador: FiltroGlosasEmpleador) => {
    var filter = "";

    if (filtroGlosasEmpleador) {
        
        filter = filtroGlosasEmpleador.dni ? `dni=${filtroGlosasEmpleador.dni}` : "";

        filter += filtroGlosasEmpleador.tipoTransaccion ?
            (filter ? `&tipoTransaccion=${filtroGlosasEmpleador.tipoTransaccion}` :
                `tipoTransaccion=${filtroGlosasEmpleador.tipoTransaccion}`)
            : "";

        filter += filtroGlosasEmpleador.estado ?
            (filter ? `&estado=${filtroGlosasEmpleador.estado}` :
                `estado=${filtroGlosasEmpleador.estado}`)
            : "";

        filter += filtroGlosasEmpleador.uen ?
            (filter ? `&uen=${filtroGlosasEmpleador.uen}` :
                `uen=${filtroGlosasEmpleador.uen}`)
            : "";

        filter += filtroGlosasEmpleador.tipoGestion ?
            (filter ? `&tipoGestion=${filtroGlosasEmpleador.tipoGestion}` :
                `tipoGestion=${filtroGlosasEmpleador.tipoGestion}`)
            : "";

        filter += filtroGlosasEmpleador.usuario ?
            (filter ? `&usuario=${filtroGlosasEmpleador.usuario}` :
            `usuario=${filtroGlosasEmpleador.usuario}`)
        : "";

        filter += filtroGlosasEmpleador.fuenteIngreso ?
            (filter ? `&fuenteIngreso=${filtroGlosasEmpleador.fuenteIngreso}` :
            `fuenteIngreso=${filtroGlosasEmpleador.fuenteIngreso}`)
        : "";

        filter += filtroGlosasEmpleador.estadoPoliza ?
            (filter ? `&estadoPoliza=${filtroGlosasEmpleador.estadoPoliza}` :
            `estadoPoliza=${filtroGlosasEmpleador.estadoPoliza}`)
        : "";

        filter += filtroGlosasEmpleador.codigoGlosa ?
            (filter ? `&codigoGlosa=${filtroGlosasEmpleador.codigoGlosa}` :
            `codigoGlosa=${filtroGlosasEmpleador.codigoGlosa}`)
        : "";

        filter += filtroGlosasEmpleador.fechaInicial ?
            (filter ? `&fechaInicial=${filtroGlosasEmpleador.fechaInicial}` :
                 `fechaInicial=${filtroGlosasEmpleador.fechaInicial}`)
            : "";

        filter += filtroGlosasEmpleador.fechaFinal ?
            (filter ? `&fechaFinal=${filtroGlosasEmpleador.fechaFinal}` :
                `fechaFinal=${filtroGlosasEmpleador.fechaFinal}`)
            : "";

        filter += filtroGlosasEmpleador.periodoInicio ?
            (filter ? `&periodoInicio=${filtroGlosasEmpleador.periodoInicio}` :
                `periodoInicio=${filtroGlosasEmpleador.periodoInicio}`)
            : "";

        filter += filtroGlosasEmpleador.periodoFin ?
            (filter ? `&periodoFin=${filtroGlosasEmpleador.periodoFin}` :
                `periodoFin=${filtroGlosasEmpleador.periodoFin}`)
            : "";

        filter += filtroGlosasEmpleador.registrosPorPagina ?
            (filter ? `&registrosPorPagina=${filtroGlosasEmpleador.registrosPorPagina}` :
                `registrosPorPagina=${filtroGlosasEmpleador.registrosPorPagina}`)
            : "";

        filter += filtroGlosasEmpleador.pagina ?
            (filter ? `&pagina=${filtroGlosasEmpleador.pagina + 1}` :
                `pagina=${filtroGlosasEmpleador.pagina + 1}`)
            : "&pagina=1";

    }
    return filter;
};

const calcularEstadoGlosasGestion = (listaRespuestaGestionGlosas: Array<RespuestaGestionGlosas>, respuestaGestionGlosa: RespuestaGestionGlosas) => {
    return (listaRespuestaGestionGlosas.some((respuestaGlosa: RespuestaGestionGlosas) => 
                        (!respuestaGlosa.exitoGestion) ) || !respuestaGestionGlosa.exitoGestion) ? REQUEST.ERROR :  REQUEST.SUCCESS;
};

const actualizarGlosasGestionadas = (glosasEmpleador: Array<GlosaEmpleador>, glosaEmpleadorGestionada: GlosaEmpleador) => {
    return glosasEmpleador.map(glosa1 => {
        const glosaEncontrada = (
            glosa1.dniEmpleador === glosaEmpleadorGestionada.dniEmpleador 
                && glosa1.codigoGlosa === glosaEmpleadorGestionada.codigoGlosa 
                    &&  glosa1.consecutivo === glosaEmpleadorGestionada.consecutivo
                        && glosa1.codigoServicio === glosaEmpleadorGestionada.codigoServicio
        );
        if(glosaEncontrada) {
            glosa1 = Object.assign(glosa1, glosaEncontrada);
            glosa1.estado = EstadoGlosa.enproceso;
        }
        return glosa1;
    });
};

const actualizarGlosasGestionFallo = (glosasEmpleador: Array<GlosaEmpleador>, glosasProcesada: RespuestaGestionGlosas) => {
    return glosasEmpleador.map(glosa1 => {
        const glosaEncontrada = (
            !glosasProcesada.exitoGestion &&
                glosa1.dniEmpleador === glosasProcesada.glosaEmpleador.dniEmpleador 
                    && glosa1.codigoGlosa === glosasProcesada.glosaEmpleador.codigoGlosa 
                        &&  glosa1.consecutivo === glosasProcesada.glosaEmpleador.consecutivo
                            && glosa1.codigoServicio === glosasProcesada.glosaEmpleador.codigoServicio
        );
        if(glosaEncontrada) {
            glosa1 = Object.assign(glosa1, glosaEncontrada);
            glosa1.estado = EstadoGlosa.pendiente;
        }
        return glosa1;
    });
};

const adicionarListaRespuestaGlosaProcesada = (listaRespuestaGestionGlosas: Array<RespuestaGestionGlosas>, respuestaGestionGlosa: RespuestaGestionGlosas) => {
    let lista = listaRespuestaGestionGlosas;
    lista.push(respuestaGestionGlosa);
    return lista;
};

const masivoGlosasGestionadas = (glosasEmpleador: Array<GlosaEmpleador>) => {
    return glosasEmpleador.map(glosa => {
        if(glosa.estado === EstadoGlosa.pendiente || glosa.estado === EstadoGlosa.gestionar || glosa.estado === EstadoGlosa.invalido) {
            glosa.estado = EstadoGlosa.enproceso;
        }
        return glosa;
    });
};

const construirXLS = (respuestaHttp: DatosGlosasXLS, tipoGlosa: TIPO_GLOSA_SAT) => {
    /*Libros a generar en el XLS*/
    const libroGlosas = 'Glosas SAT';
    const librosXLS = [libroGlosas];

    /*Datos para el libro de Glosas*/
    const datosGlosas = respuestaHttp.glosasEmpleador.map((glosaEmpleador: GlosaEmpleador) => {
        const usuarioOperacion: string = glosaEmpleador.usuario ? glosaEmpleador.usuario : '';
        const datosServicio = respuestaHttp.transaccionesSat.find(transaccion => transaccion.codigo.toString() === glosaEmpleador.codigoServicio.toString());
        if(tipoGlosa === TIPO_GLOSA_SAT.NOVEDADES) {
            const datosUen = respuestaHttp.uenActivas.find(uen => uen.codigo === glosaEmpleador.uen);
            return [
                {value: glosaEmpleador.dniEmpleador},
                {value: glosaEmpleador.npoliza ? glosaEmpleador.npoliza : ''},
                {value: glosaEmpleador.estadoPoliza ? glosaEmpleador.estadoPoliza : ''},
                {value: glosaEmpleador.nombreEmpleador ? glosaEmpleador.nombreEmpleador : ''},
                {value: datosUen ? `${datosUen.codigo} - ${datosUen.nombre}` : ''},
                {value: datosServicio ? datosServicio.nombre : ''},
                {value: glosaEmpleador.codigoServicio},
                {value: glosaEmpleador.consecutivo},
                {value: glosaEmpleador.fechaOperacion ? moment(glosaEmpleador.fechaOperacion).format(DATE_FORMAT_WITH_HOUR).replace(/\//gi,'-') : ''},
                {value: glosaEmpleador.estado ? glosaEmpleador.estado : 'DESCONOCIDO'},
                {value: usuarioOperacion === 'MODSATADMARL' ? 'AUTOMÁTICO' : usuarioOperacion},
                {value: glosaEmpleador.emailUsuario ? glosaEmpleador.emailUsuario : ''},
                {value: glosaEmpleador.codigoGlosa ? glosaEmpleador.codigoGlosa : ''},
                {value: glosaEmpleador.descripcionGlosa ? glosaEmpleador.descripcionGlosa : ''},
                {value: glosaEmpleador.detalleGlosa ? glosaEmpleador.detalleGlosa : ''},
                {value: glosaEmpleador.respuestaSat ? glosaEmpleador.respuestaSat : ''},
                {value: glosaEmpleador.fuenteIngreso ? glosaEmpleador.fuenteIngreso : ''},
                {value: glosaEmpleador.glosaBloqueante ? glosaEmpleador.glosaBloqueante : 'N/A'},
                {value: glosaEmpleador.observacionGestion ? glosaEmpleador.observacionGestion : ''}
            ];
        }
        if(tipoGlosa === TIPO_GLOSA_SAT.MORA) {
            const datosUen = respuestaHttp.uenActivas.find(uen => uen.codigo === glosaEmpleador.uen);
            const periodo = JSON.parse(glosaEmpleador.detalleGlosa).Periodo;
            const tipoReporte = JSON.parse(glosaEmpleador.detalleGlosa).TipoReporte;

            return [
                {value: glosaEmpleador.dniEmpleador},
                {value: glosaEmpleador.npoliza ? glosaEmpleador.npoliza : ''},
                {value: glosaEmpleador.estadoPoliza ? glosaEmpleador.estadoPoliza : ''},
                {value: glosaEmpleador.nombreEmpleador ? glosaEmpleador.nombreEmpleador : ''},
                {value: datosUen ? `${datosUen.codigo} - ${datosUen.nombre}` : ''},
                {value: datosServicio ? datosServicio.nombre : ''},
                {value: glosaEmpleador.codigoServicio},
                {value: glosaEmpleador.consecutivo},
                {value: glosaEmpleador.fechaOperacion ? moment(glosaEmpleador.fechaOperacion).format(DATE_FORMAT_WITH_HOUR).replace(/\//gi,'-') : ''},
                {value: glosaEmpleador.estado ? glosaEmpleador.estado : 'DESCONOCIDO'},
                {value: usuarioOperacion === 'MODSATADMARL' ? 'AUTOMÁTICO' : usuarioOperacion},
                {value: glosaEmpleador.emailUsuario ? glosaEmpleador.emailUsuario : ''},
                {value: glosaEmpleador.codigoGlosa ? glosaEmpleador.codigoGlosa : ''},
                {value: periodo ? periodo : ''},
                {value: tipoReporte ? tipoReporte : ''},
                {value: glosaEmpleador.descripcionGlosa ? glosaEmpleador.descripcionGlosa : ''},
                {value: glosaEmpleador.detalleGlosa ? glosaEmpleador.detalleGlosa : ''},
                {value: glosaEmpleador.respuestaSat ? glosaEmpleador.respuestaSat : ''},
                {value: glosaEmpleador.fuenteIngreso ? glosaEmpleador.fuenteIngreso : ''},
                {value: glosaEmpleador.glosaBloqueante ? glosaEmpleador.glosaBloqueante : 'N/A'},
                {value: glosaEmpleador.observacionGestion ? glosaEmpleador.observacionGestion : ''}
            ];
        } else {
            return [
                {value: glosaEmpleador.dniEmpleador},
                {value: glosaEmpleador.npoliza ? glosaEmpleador.npoliza : ''},
                {value: glosaEmpleador.estadoPoliza ? glosaEmpleador.estadoPoliza : ''},
                {value: datosServicio ? datosServicio.nombre : ''},
                {value: glosaEmpleador.consecutivo},
                {value: glosaEmpleador.fechaOperacion ? moment(glosaEmpleador.fechaOperacion).format(DATE_FORMAT_WITH_HOUR).replace(/\//gi,'-') : '' },
                {value: glosaEmpleador.estado ? glosaEmpleador.estado : 'DESCONOCIDO'},
                {value: usuarioOperacion === 'MODSATADMARL' ? 'AUTOMÁTICO' : usuarioOperacion},
                {value: glosaEmpleador.codigoGlosa ? glosaEmpleador.codigoGlosa : ''},
                {value: glosaEmpleador.descripcionGlosa ? glosaEmpleador.descripcionGlosa : ''},
                {value: glosaEmpleador.detalleGlosa ? glosaEmpleador.detalleGlosa : ''},
                {value: glosaEmpleador.respuestaSat ? glosaEmpleador.respuestaSat : ''},
                {value: glosaEmpleador.fuenteIngreso ? (glosaEmpleador.fuenteIngreso === '04' ? 'DIRECTO' : 
                        (['08','09'].indexOf(glosaEmpleador.fuenteIngreso) !== -1 ? 'COMERCIAL': glosaEmpleador.fuenteIngreso) ) : ''},
                {value: glosaEmpleador.glosaBloqueante ? glosaEmpleador.glosaBloqueante : 'N/A'},
                {value: glosaEmpleador.observacionGestion ? glosaEmpleador.observacionGestion : ''},
            ];
        }
    });

    /*Datos para generar el XLS*/
    const datosLibrosXLS: LibroDocumentoXLS[] = [{
        nombreLibro: libroGlosas,
        cabecera: cabeceraGlosasSAT(tipoGlosa),
        datos: datosGlosas,
    }];

    return crearPlantillaXLS(librosXLS, datosLibrosXLS);
};

const definirTipo = (action: any) => {
    if ( action.filtroGlosasEmpleador.tipoTransaccion === 12) return TIPO_GLOSA_SAT.MORA;
    return action.filtroGlosasEmpleador.tipoTransaccion === 1 || action.filtroGlosasEmpleador.tipoTransaccion === 4 ? TIPO_GLOSA_SAT.AFILIACIONES : TIPO_GLOSA_SAT.NOVEDADES;
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/inconsistencias/modulos/bandejaGlosasReducers.ts